import cx from 'classnames';
import { useContext } from 'react';

import DocsContext from '../../../contexts/docs';
import Community from './Community';

import Divider from '../Layout/Divider';
import FullWidth from '../Layout/FullWidth';
import styles from './index.module.scss';
import PrivacyChoices from './PrivacyChoices';

const Footer = () => {
  const { metadata } = useContext(DocsContext);

  return (
    <footer className={styles.footerContainer} data-algolia-remove='true'>
      <FullWidth>
        <Divider />
        <div className={cx(styles.footerItems)}>
          <Community />
          <PrivacyChoices />
        </div>
      </FullWidth>
    </footer>
  );
};

Footer.displayName = 'Footer';
export default Footer;
